import { generateOpenApi } from '@ts-rest/open-api';
import { formTransferContract } from './formTransfer.contract.js';

export const formTransferOpenApiSpec = generateOpenApi(
  formTransferContract,
  {
    info: {
      title: 'Skewb Works Form Transfer API',
      version: '1.0.0',
      description:
        'Export and import of a whole form definition (form, sections, controls and form ' +
        'type) as a portable JSON package. Requires the FormTransfer permission: read to ' +
        'export, create to import.',
      contact: {
        name: 'Skewb Works Development Team',
      },
    },
    servers: [
      {
        url: 'https://localhost:8080',
        description: 'Local development server',
      },
      {
        url: 'https://api.works-works-lite.dev.skewbdigital.co.uk',
        description: 'Dev API server',
      },
    ],
    tags: [
      {
        name: 'Form Transfer',
        description: 'Export and import a form definition',
      },
    ],
  },
  {
    setOperationId: true,
    operationMapper: (operation) => ({
      ...operation,
      tags: ['Form Transfer'],
    }),
  },
);
